import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addLeavePolicyAssign = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Leave Policy Assignment',
    body
  );
  return data;
});
export const updateLeavePolicyAssign = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Leave Policy Assignment/${id}`,
    body
  );
  return data;
});

export const getLeavePolicyAssign = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Leave Policy Assignment?fields=["name","docstatus","employee_name","leave_policy"]&limit_page_length=10&limit_start=0&order_by=creation desc'
  );
  return data;
});
export const deleteLeavePolicyAssign = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Leave Policy Assignment/${record}`
  );
  return data;
});
export const getLeavePolicyAssignDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Leave Policy Assignment/${id}`
  );
  return data;
});
